import PropTypes from 'prop-types';
import styles from './FJCommunityMySpace.module.less';
import FJEditIcon from '../../../../assets/svg/community/edit.svg?react';
import FJLocalStore from '../../../../store/FJLocalStore';
import classNames from 'classnames';
import FJTab from '../../../../common/components/FJTab/FJTab';
import FJSharedCreationsContainer from './FJSharedCreations/FJSharedCreationsContainer';
import FJMyLikeContainer from './FJMyLike/FJMyLikeContainer';
import FJMyCreationsContainer from './FJMyCreations/FJMyCreationsContainer';
import FJUtil from '../../../../util/FJUtil';
import FJCommunitySelectAllContainer from '../FJCommunitySelectAll/FJCommunitySelectAllContainer';
import FJConfig from '../../../../config/FJConfig';
import FJConstant from '../../../../constants/FJConstant';
import { useMemo } from 'react';
import FJMyCreationsDetailContainer from './FJMyCreationsDetail/FJMyCreationsDetailContainer';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
const TOTAL_SCROLL_THRESHOLD = 1000;
const FJCommunityMySpace = props => {
    const {
        active,
        userInfo,
        mySpaceTabType,
        onMySpaceTabChange,
        isLoadedPage,
        guestUserInfo,
        tabList,
        onTotalScroll,
        myCreationsPageScene,
    } = props;
    const { avatar, username, likeNum } = userInfo;
    const onEditUserClick = () => {
        window.open(FJUtil.getCurrentUrl() + 'profile.html', '_blank');
    };
    const mySpaceTabTypeIndex = useMemo(() => {
        return tabList.findIndex(item => item.type === mySpaceTabType);
    }, [tabList, mySpaceTabType]);
    const _onMySpaceTabChange = index => {
        const { type } = tabList[index];
        onMySpaceTabChange(type);
    };
    const _renderHeader = () => {
        return (
            <>
                <div
                    className={styles.header}
                    style={{
                        backgroundImage: `url(${FJConfig.imgPath}community/my-space-bg.png)`,
                    }}
                >
                    <div className={styles.header_left}>
                        {avatar && <img className={styles.avatar} src={avatar} alt={'avatar'} />}
                    </div>
                    <div className={styles.header_right}>
                        <div className={styles.name_box}>
                            <div className={styles.name}>{username}</div>
                            {!guestUserInfo.guestMode && (
                                <div className={styles.edit_icon_box} onClick={onEditUserClick}>
                                    <FJEditIcon className={styles.edit_icon} />
                                </div>
                            )}
                        </div>
                        <div className={styles.like_box}>
                            {FJLocalStore._('liked')}：{likeNum}
                        </div>
                    </div>
                </div>
                <div className={styles.header_footer}>
                    <FJTab
                        dataList={tabList}
                        textClassName={styles.tab_text}
                        selectClassName={styles.tab_box}
                        lineClass={styles.line}
                        selectedIndex={mySpaceTabTypeIndex}
                        onChange={_onMySpaceTabChange}
                    />
                </div>
            </>
        );
    };

    return (
        <>
            <FJVerticalScroller
                className={classNames(styles.container, active ? styles.show : styles.hide)}
                onTotalScroll={onTotalScroll}
                totalScrollThreshold={TOTAL_SCROLL_THRESHOLD}
            >
                {_renderHeader()}
                {isLoadedPage.myCreations && (
                    <FJMyCreationsContainer
                        active={
                            mySpaceTabType === FJConstant.MY_CREATIONS && myCreationsPageScene === FJConstant.DEFAULT
                        }
                    />
                )}
                {isLoadedPage.myCreationsDetail && (
                    <FJMyCreationsDetailContainer
                        active={
                            mySpaceTabType === FJConstant.MY_CREATIONS && myCreationsPageScene === FJConstant.DETAIL
                        }
                    />
                )}
                {isLoadedPage.sharedCreations && (
                    <FJSharedCreationsContainer active={mySpaceTabType === FJConstant.SHARED_CREATIONS} />
                )}
                {isLoadedPage.likedCreations && (
                    <FJMyLikeContainer active={mySpaceTabType === FJConstant.LIKED_CREATIONS} />
                )}
            </FJVerticalScroller>
            <FJCommunitySelectAllContainer />
        </>
    );
};

FJCommunityMySpace.propTypes = {
    active: PropTypes.bool,
    userInfo: PropTypes.shape({
        avatar: PropTypes.string,
        username: PropTypes.string,
        likeNum: PropTypes.number,
    }),
    mySpaceTabType: PropTypes.string,
    onMySpaceTabChange: PropTypes.func,
    isLoadedPage: PropTypes.shape({
        myCreations: PropTypes.bool,
        myCreationsDetail: PropTypes.bool,
        sharedCreations: PropTypes.bool,
        likedCreations: PropTypes.bool,
    }),
    guestUserInfo: PropTypes.shape({
        guestMode: PropTypes.bool,
        avatar: PropTypes.string,
        username: PropTypes.string,
        likeNum: PropTypes.number,
    }),
    tabList: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string,
            text: PropTypes.string,
        }),
    ),
    onTotalScroll: PropTypes.func,
    myCreationsPageScene: PropTypes.string,
};

export default FJCommunityMySpace;
